var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-add"},[_c('div',{directives:[{name:"viewer",rawName:"v-viewer",value:(_vm.viewerProps),expression:"viewerProps"}],staticClass:"uploaded-images",on:{"click":function($event){$event.stopPropagation();}}},[_c('img',{attrs:{"src":_vm.uploadedFile}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12b0aa49","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fb/ImageViewer.vue
// module id = 956
// module chunks = 1